import React, { useEffect, useState } from 'react'
import { Tooltip, Modal } from 'antd'


import { ISasPropostaOrdemCompra } from '@app/api/sas/sasProposta'
import { Button } from '@digital/ui'
import { Space, Visibility } from '@app/components'
import ModalConfirmarPropostaComercial from './ModalConfirmarPropostaComercial'
import ModalRecusaPropostaComercial from './ModalRecusaPropostaComercial'
import { downloadArquivo, downloadArquivosOrdemCompra, getArquivosDocumentoOrdemCompraByOc, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra'
import { UploadModalHistorico } from '@app/components/Upload/uploadModalHistorico'
import { useRecoilState, useRecoilValue } from 'recoil'
import { dadosIdentificacaoState, editandoState, modalAcoesIdState, ordemCompraIdState } from '../../atoms'
import { IArquivo } from '@app/types/core.types'
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento'
import { toUpperCaseFirstChar } from '@app/helpers/stringHelper'

interface Props {
    sasPropostaId: string
    sasProposta: ISasPropostaOrdemCompra
}


const ButtonConfirmarPropostaComercial = (props: Props) => {
    const { sasPropostaId, sasProposta } = props
    const [enviado, setEnviado] = useState(false)
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const dadosIdentificacao = useRecoilValue(dadosIdentificacaoState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const [editando, setEditando] = useRecoilState(editandoState);

    useEffect(() => {
        if (sasProposta.statusPropostaComercial) {
            if (sasProposta.statusPropostaComercial !== 'Pendente') {
                setEnviado(true)
            }
        }
    }, [sasProposta])


    return (
        <>
            <Visibility visible={enviado === false} >
                <Tooltip title={"Proposta Comercial " + toUpperCaseFirstChar(sasProposta.statusPropostaComercial || "Recebida")} >
                    <Button icon="ui-checked" onClick={() => setEnviado(true)} />
                </Tooltip>
            </Visibility>
            <Visibility visible={
                (enviado === true && !sasProposta.statusPropostaComercial) ||
                (sasProposta.statusPropostaComercial === 'Recebida') ||
                editando.sasPropostaId === sasPropostaId
            }>
                <ModalConfirmarPropostaComercial sasPropostaId={sasPropostaId} sasProposta={sasProposta} />
                <Visibility visible={(sasProposta.statusPropostaComercial === 'Recebida')}>
                    <Space ml={4} />
                    <UploadModalHistorico
                        tooltip="Arquivos Proposta Comercial"
                        title="Arquivos Proposta Comercial"
                        hasJustification={false}
                        hasDatePicker={false}
                        hasUpload={false}
                        onGetArquivos={async () => {
                            const result = await getArquivosDocumentoOrdemCompraByOc({
                                ordemCompraId,
                                sasTipoDocumentoId: EGuidTipoSasDocumento.AceitePropostaComercial,
                                sasPropostaId,
                            }).then((data) => {
                                return data || [];
                            });
                            return result
                        }}
                        arquivoActions={{
                            onDownload: (arquivo: IArquivo) => {
                                downloadArquivo(
                                    arquivo.id,
                                    arquivo.nome
                                );
                            },
                            onView(arquivo: IArquivo) {
                                viewArquivo(
                                    arquivo.id,
                                    arquivo.nome
                                );
                            },
                        }}
                        onDownloadAllArquivos={async () => {
                            await downloadArquivosOrdemCompra({
                                ordemCompraId: dadosIdentificacao.id,
                                ordemCompraNumero: dadosIdentificacao.numero,
                                nomeArquivo: 'proposta_comercial',
                                sasTipoDocumentoOrdemCompraId: EGuidTipoSasDocumento.AceitePropostaComercial,
                                sasPropostaId: sasPropostaId
                            })
                        }}
                    />
                </Visibility>
            </Visibility>
            <Space ml={4} />
            <Visibility visible={enviado === false || (
                sasProposta.statusPropostaComercial === 'Declinou' ||
                sasProposta.statusPropostaComercial === 'Sem Resposta' ||
                editando.sasPropostaId === sasPropostaId
            )}>
                <ModalRecusaPropostaComercial sasPropostaId={sasPropostaId} sasProposta={sasProposta} />
            </Visibility>
        </>
    )
}

export default ButtonConfirmarPropostaComercial